export default __webpack_public_path__ + "static/media/Comp 2_00048.49eb4e93.png";